<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">31 DECEMBER 2020</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="white bolder font">KUWAIT</td>
                            <td class="white bolder font">JORDAN</td>
                            <td class="white bolder font">SUDAN</td>
                            <td class="white bolder font">IRAQ</td>
                            <td class="white bolder font">BAHRAIN</td>
                            <td class="white bolder font">KSA</td>
                            <td class="white bolder font">OTHERS</td>
                            <td class="white bolder font">TOTAL</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue">Segment revenues
                                <br/> <span class="font">– airtime, data & subscriptions (Over time)</span></td>
                            <td class="font">241,390</td>
                            <td class="font">143,276</td>
                            <td class="font">125,987</td>
                            <td class="font">287,999</td>
                            <td class="font">41,134</td>
                            <td class="font">583,215</td>
                            <td class="font">42,917</td>
                            <td class="font">1,465,918</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Segment revenues
                                <br/> <span class="font">- trading income<br> (Point in time)</span></td>
                            <td class="font">79,229</td>
                            <td class="font">5,798</td>
                            <td class="font">1,565</td>
                            <td class="font">940</td>
                            <td class="font">9,252</td>
                            <td class="font">64,043</td>
                            <td class="font">140</td>
                            <td class="font">160,967</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Net profit before interest and tax</td>
                            <td class="font">69,416</td>
                            <td class="font">37,051</td>
                            <td class="font">27,463</td>
                            <td class="font">46,896</td>
                            <td class="font">5,216</td>
                            <td class="font">82,620</td>
                            <td class="font">15,841</td>
                            <td class="font">284,503</td>
                        </tr>
                        <tr>
                            <td class="font">Interest income</td>
                            <td class="font">1,373</td>
                            <td class="font">447</td>
                            <td class="font">319</td>
                            <td class="font">755</td>
                            <td class="font">184</td>
                            <td class="font">978</td>
                            <td class="font"> 92</td>
                            <td class="font">4,148</td>
                        </tr>
                        <tr>
                            <td class="font">Gain on sale and lease back transactions</td>
                            <td class="font">6,205</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">6,205</td>
                        </tr>
                        <tr>
                            <td class="font">Gain on modification of financial liabilities</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">11,128</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">11,128</td>
                        </tr>
                        <tr>
                            <td class="font">Finance costs</td>
                            <td class="font">(571)</td>
                            <td class="font">(5,534)</td>
                            <td class="font">(1,159)</td>
                            <td class="font">(13,897)</td>
                            <td class="font">(1,013)</td>
                            <td class="font">(73,478)</td>
                            <td class="font">(41)</td>
                            <td class="font">(95,693)</td>
                        </tr>
                        <tr>
                            <td class="font">Income tax expenses</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">(7,724)</td>
                            <td class="font">(8,030)</td>
                            <td class="font">(6,986)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">(341) </td>
                            <td class="font">(23,081)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">76,423</td>
                            <td class="font white bold">24,240</td>
                            <td class="font white bold">18,593</td>
                            <td class="font white bold">26,768</td>
                            <td class="font white bold">4,387</td>
                            <td class="font white bold">21,248</td>
                            <td class="font white bold">15,551</td>
                            <td class="font white bold">187,210</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Unallocated items:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">Investment income</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right"> 2,021</td>
                        </tr>
                        <tr>
                            <td class="font">Share of results of associates and joint venture</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">766</td>
                        </tr>
                        <tr>
                            <td class="font">Others (including unallocated interest income,income tax and finance costs net of elimination)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">18,210</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">Profit for the year</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white text-right">208,207</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Segment assets including allocated goodwill</td>
                            <td class="font">408,733</td>
                            <td class="font">333,623</td>
                            <td class="font">154,321</td>
                            <td class="font">1,129,755</td>
                            <td class="font">91,419</td>
                            <td class="font">2,225,641</td>
                            <td class="font">82,629</td>
                            <td class="font text-right">4,426,121</td>
                        </tr>
                        <tr>
                            <td class="font">ROU asset</td>
                            <td class="font">7,005</td>
                            <td class="font">18,165</td>
                            <td class="font">2,532</td>
                            <td class="font">27,516</td>
                            <td class="font">9,871</td>
                            <td class="font">104,050</td>
                            <td class="font">153</td>
                            <td class="font text-right">169,292</td>
                        </tr>
                        <tr>
                            <td class="font">Unallocated items:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible text-right">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">Investment securities at FVTPL</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">9,785</td>
                        </tr>
                        <tr>
                            <td class="font">Investment securities at FVOCI </td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">5,325</td>
                        </tr>
                        <tr>
                            <td class="font">Investment in associates and joint venture</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">76,137</td>
                        </tr>
                        <tr>
                            <td class="font">Others (net of eliminations)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">224,904</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">Consolidated assets </td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white text-right">4,911,564</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Segment liabilities</td>
                            <td class="font">117,135</td>
                            <td class="font">130,524</td>
                            <td class="font">57,063</td>
                            <td class="font">251,551</td>
                            <td class="font">30,533</td>
                            <td class="font">1,157,488</td>
                            <td class="font">75,311</td>
                            <td class="font text-right">1,819,605</td>
                        </tr>
                        <tr>
                            <td class="font">Lease liabilities (Current & non-current)</td>
                            <td class="font">13,668</td>
                            <td class="font">18,619</td>
                            <td class="font">1,968</td>
                            <td class="font">25,712 </td>
                            <td class="font">9,948</td>
                            <td class="font">112,096</td>
                            <td class="font">117</td>
                            <td class="font text-right">182,128</td>
                        </tr>
                        <tr>
                            <td class="font">Due to banks</td>
                            <td class="font">-</td>
                            <td class="font">28,848</td>
                            <td class="font">-</td>
                            <td class="font">202,894 </td>
                            <td class="font">-</td>
                            <td class="font">310,651</td>
                            <td class="font">-</td>
                            <td class="font text-right">542,393</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">130,803</td>
                            <td class="font white bold">177,991</td>
                            <td class="font white bold">59,031</td>
                            <td class="font white bold">480,157</td>
                            <td class="font white bold">40,481</td>
                            <td class="font white bold">1,580,235</td>
                            <td class="font white bold">75,428</td>
                            <td class="font white bold text-right">2,544,126</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">Unallocated items:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible text-right">asdf</span></td>
                        </tr>
                    </tbody>
                    <tr>
                        <td class="font">Due to banks</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font text-right">653,983</td>
                    </tr>
                    <tr>
                        <td class="font">Others (net of eliminations)</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font text-right">(221,089)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Consolidated liabilities</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white text-right">2,977,020 </td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Net consolidated assets</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white text-right"> 1,934,544</td>
                    </tr>
                    <tr>
                        <td class="font">Capital expenditure incurred during the year</td>
                        <td class="font">30,946</td>
                        <td class="font">20,823 </td>
                        <td class="font">33,565</td>
                        <td class="font">78,313</td>
                        <td class="font">19,092</td>
                        <td class="font">240,127</td>
                        <td class="font">14,344</td>
                        <td class="font text-right">437,210</td>
                    </tr>
                    <tr>
                        <td class="font">Unallocated (net of eliminations)</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font text-right">(21,812)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Total capital expenditure</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font white text-right"> 415,398</td>
                    </tr>
                    <tr>
                        <td class="font">Depreciation and amortization</td>
                        <td class="font">33,316</td>
                        <td class="font">25,851 </td>
                        <td class="font">10,345</td>
                        <td class="font">55,288</td>
                        <td class="font">8,870</td>
                        <td class="font">168,906</td>
                        <td class="font">4,313</td>
                        <td class="font text-right">306,889</td>
                    </tr>
                    <tr>
                        <td class="font">Amortization of ROU assets</td>
                        <td class="font">5,786</td>
                        <td class="font">3,545</td>
                        <td class="font">542</td>
                        <td class="font">6,709 </td>
                        <td class="font">3,335</td>
                        <td class="font">30,539</td>
                        <td class="font">179</td>
                        <td class="font text-right">50,635</td>
                    </tr>
                    <tr>
                        <td class="font">Unallocated </td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font text-right">3,199</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">Total depreciation and amortization</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white text-right">360,723</td>
                    </tr>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">31 ديسمبر 2020</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="white bolder font">الكويت</td>
                            <td class="white bolder font">الأردن</td>
                            <td class="white bolder font">السودان</td>
                            <td class="white bolder font">العراق</td>
                            <td class="white bolder font">البحرين</td>
                            <td class="white bolder font">السعودية</td>
                            <td class="white bolder font">أخرى</td>
                            <td class="white bolder font">المجموع</td>
                        </tr>
                        <tr class="light-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="8" class="white center bolder font">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font skyBlue">إيرادات القطاع
                                <br/> <span class="font">_ مكالمات وبيانات واشتراكات (مع مرور الوقت)</span></td>
                            <td class="font">241,390</td>
                            <td class="font">143,276</td>
                            <td class="font">125,987</td>
                            <td class="font">287,999</td>
                            <td class="font">41,134</td>
                            <td class="font">583,215</td>
                            <td class="font">42,917</td>
                            <td class="font">1,465,918</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">إيرادات القطاع
                                <br/> <span class="font">_ إيرادات المتاجرة (عند نقطة زمنية محددة)</span></td>
                            <td class="font">79,229</td>
                            <td class="font">5,798</td>
                            <td class="font">1,565</td>
                            <td class="font">940</td>
                            <td class="font">9,252</td>
                            <td class="font">64,043</td>
                            <td class="font">140</td>
                            <td class="font">160,967</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">صافي الربح قبل الفوائد والضرائب</td>
                            <td class="font">69,416</td>
                            <td class="font">37,051</td>
                            <td class="font">27,463</td>
                            <td class="font">46,896</td>
                            <td class="font">5,216</td>
                            <td class="font">82,620</td>
                            <td class="font">15,841</td>
                            <td class="font">284,503</td>
                        </tr>
                        <tr>
                            <td class="font">إيرادات فوائد</td>
                            <td class="font">1,373</td>
                            <td class="font">447</td>
                            <td class="font">319</td>
                            <td class="font">755</td>
                            <td class="font">184</td>
                            <td class="font">978</td>
                            <td class="font"> 92</td>
                            <td class="font">4,148</td>
                        </tr>
                        <tr>
                            <td class="font">ربح نتيجة معاملات بيع مع إعادة استئجار</td>
                            <td class="font">6,205</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">6,205</td>
                        </tr>
                        <tr>
                            <td class="font">ربح نتيجة تعديل مطلوبات مالية</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">11,128</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">11,128</td>
                        </tr>
                        <tr>
                            <td class="font">أعباء تمويل</td>
                            <td class="font">(571)</td>
                            <td class="font">(5,534)</td>
                            <td class="font">(1,159)</td>
                            <td class="font">(13,897)</td>
                            <td class="font">(1,013)</td>
                            <td class="font">(73,478)</td>
                            <td class="font">(41)</td>
                            <td class="font">(95,693)</td>
                        </tr>
                        <tr>
                            <td class="font">مصاريف ضريبة الدخل</td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">(7,724)</td>
                            <td class="font">(8,030)</td>
                            <td class="font">(6,986)</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="font">(341) </td>
                            <td class="font">(23,081)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">76,423</td>
                            <td class="font white bold">24,240</td>
                            <td class="font white bold">18,593</td>
                            <td class="font white bold">26,768</td>
                            <td class="font white bold">4,387</td>
                            <td class="font white bold">21,248</td>
                            <td class="font white bold">15,551</td>
                            <td class="font white bold">187,210</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">بنود غير موزعة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">إيرادات استثمارات</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right"> 2,021</td>
                        </tr>
                        <tr>
                            <td class="font">حصة في نتائج شركات زميلة <br/>ومشروع مشترك</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">766</td>
                        </tr>
                        <tr>
                            <td class="font">أخرى (تتضمن إيرادات فوائد وضريبة دخل <br/>وأعباء تمويل غير موزعة، بالصافي من استبعادات)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">18,210</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">ربح السنة</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white text-right">208,207</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">موجودات القطاع بما في ذلك الشهرة الموزعة</td>
                            <td class="font">408,733</td>
                            <td class="font">333,623</td>
                            <td class="font">154,321</td>
                            <td class="font">1,129,755</td>
                            <td class="font">91,419</td>
                            <td class="font">2,225,641</td>
                            <td class="font">82,629</td>
                            <td class="font text-right">4,426,121</td>
                        </tr>
                        <tr>
                            <td class="font">أصول حق الاستخدام</td>
                            <td class="font">7,005</td>
                            <td class="font">18,165</td>
                            <td class="font">2,532</td>
                            <td class="font">27,516</td>
                            <td class="font">9,871</td>
                            <td class="font">104,050</td>
                            <td class="font">153</td>
                            <td class="font text-right">169,292</td>
                        </tr>
                        <tr>
                            <td class="font">بنود غير موزعة:</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible text-right">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="font">استثمارات في أوراق مالية بالقيمة العادلة<br/>من خلال بيان الربح أو الخسارة</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">9,785</td>
                        </tr>
                        <tr>
                            <td class="font">استثمارات في أوراق مالية بالقيمة العادلة<br/>من خلال الدخل الشامل الآخر</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">5,325</td>
                        </tr>
                        <tr>
                            <td class="font">استثمارات في شركات زميلة ومشروع مشترك</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">76,137</td>
                        </tr>
                        <tr>
                            <td class="font">أخرى (بالصافي من استبعادات)</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td class="font text-right">224,904</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white">الموجودات المجمعة</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="white">-</td>
                            <td class="font white text-right">4,911,564</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">مطلوبات القطاع</td>
                            <td class="font">117,135</td>
                            <td class="font">130,524</td>
                            <td class="font">57,063</td>
                            <td class="font">251,551</td>
                            <td class="font">30,533</td>
                            <td class="font">1,157,488</td>
                            <td class="font">75,311</td>
                            <td class="font text-right">1,819,605</td>
                        </tr>
                        <tr>
                            <td class="font">التزامات عقد إيجار (متداولة وغير متداولة)</td>
                            <td class="font">13,668</td>
                            <td class="font">18,619</td>
                            <td class="font">1,968</td>
                            <td class="font">25,712 </td>
                            <td class="font">9,948</td>
                            <td class="font">112,096</td>
                            <td class="font">117</td>
                            <td class="font text-right">182,128</td>
                        </tr>
                        <tr>
                            <td class="font">مستحق لبنوك</td>
                            <td class="font">-</td>
                            <td class="font">28,848</td>
                            <td class="font">-</td>
                            <td class="font">202,894 </td>
                            <td class="font">-</td>
                            <td class="font">310,651</td>
                            <td class="font">-</td>
                            <td class="font text-right">542,393</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="font white bold">130,803</td>
                            <td class="font white bold">177,991</td>
                            <td class="font white bold">59,031</td>
                            <td class="font white bold">480,157</td>
                            <td class="font white bold">40,481</td>
                            <td class="font white bold">1,580,235</td>
                            <td class="font white bold">75,428</td>
                            <td class="font white bold text-right">2,544,126</td>
                        </tr>
                        <tr>
                            <td class="font skyBlue">بنود غير موزعة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible text-right">asdf</span></td>
                        </tr>
                    </tbody>
                    <tr>
                        <td class="font">مستحق لبنوك</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font text-right">653,983</td>
                    </tr>
                    <tr>
                        <td class="font">أخرى (بالصافي من استبعادات)</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font text-right">(221,089)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">المطلوبات المجمعة</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white text-right">2,977,020 </td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">صافي الموجودات المجمعة</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white text-right"> 1,934,544</td>
                    </tr>
                    <tr>
                        <td class="font">نفقات رأسمالية متكبدة خلال السنة</td>
                        <td class="font">30,946</td>
                        <td class="font">20,823 </td>
                        <td class="font">33,565</td>
                        <td class="font">78,313</td>
                        <td class="font">19,092</td>
                        <td class="font">240,127</td>
                        <td class="font">14,344</td>
                        <td class="font text-right">437,210</td>
                    </tr>
                    <tr>
                        <td class="font">غير موزعة (بالصافي من استبعادات)</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font text-right">(21,812)</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">إجمالي النفقات الرأسمالية</td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td><span class="invisible">asdf</span></td>
                        <td class="font white text-right"> 415,398</td>
                    </tr>
                    <tr>
                        <td class="font">استهلاكات وإطفاءات</td>
                        <td class="font">33,316</td>
                        <td class="font">25,851 </td>
                        <td class="font">10,345</td>
                        <td class="font">55,288</td>
                        <td class="font">8,870</td>
                        <td class="font">168,906</td>
                        <td class="font">4,313</td>
                        <td class="font text-right">306,889</td>
                    </tr>
                    <tr>
                        <td class="font">إطفاء أصول حق الاستخدام</td>
                        <td class="font">5,786</td>
                        <td class="font">3,545</td>
                        <td class="font">542</td>
                        <td class="font">6,709 </td>
                        <td class="font">3,335</td>
                        <td class="font">30,539</td>
                        <td class="font">179</td>
                        <td class="font text-right">50,635</td>
                    </tr>
                    <tr>
                        <td class="font">غير موزعة</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td class="font text-right">3,199</td>
                    </tr>
                    <tr class="dark-gray">
                        <td class="font white">مجموع الاستهلاكات والإطفاءات</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="white">-</td>
                        <td class="font white text-right">360,723</td>
                    </tr>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>